import React, { FC, ReactNode } from 'react';

import { Head, HeadProps } from '../Head';

export interface HeadWrapperProps extends HeadProps {
  readonly children?: ReactNode;
}

export const HeadWrapper: FC<HeadWrapperProps> = ({
  children,
  ...headProps
}) => {
  return (
    <>
      <Head {...headProps}></Head>
      {children}
    </>
  );
};
